import type { PreviewPlanFromWizardRequestDto } from '@evimo/client/models';
import { PreventiveMaintenancePlanPriority } from '@evimo/types/enums/preventive-maintenance-plan-priority';
import type { WizardData } from '~/app/components/maintenance/preventive/wizard/types';

export const PRIORITY_COLOR: Record<string, string> = {
  HIGH: 'red',
  MEDIUM: 'orange',
  LOW: 'blue',
};

export const INITIAL_WIZARD_DATA: WizardData = {
  code: '',
  name: '',
  priority: PreventiveMaintenancePlanPriority.MEDIUM,
  active: true,
  schedulingHorizonDays: 90,
  tasks: [],
  assetIds: [],
  replaceAssetIds: [],
  startDate: '',
  checkedConflicts: [],
  conflictDecisions: {},
  conflictsChecked: false,
};

export function buildWizardPayload(
  data: WizardData,
): PreviewPlanFromWizardRequestDto {
  return {
    code: data.code.trim(),
    name: data.name.trim(),
    priority: data.priority,
    schedulingHorizonDays: data.schedulingHorizonDays,
    tasks: data.tasks.map((task, i) => ({
      taskId: task.taskId,
      triggerId: task.triggerId,
      sequence: i + 1,
    })),
    ...(data.assetIds.length > 0
      ? {
          assign: {
            assetIds: data.assetIds,
            replaceAssetIds: data.replaceAssetIds,
            startDate: new Date(
              data.startDate || new Date().toISOString().split('T')[0],
            ),
          },
        }
      : {}),
  };
}
